import Animator from "./Animator";

const animator = new Animator();

export { animator };
export { default as Animation } from "./Animation";
